<template>
  <div id="app" class="login-container">
  <router-view/>
  </div>

</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
}
.login-container {
  height: 100vh;
  background: linear-gradient(to right, #00bfff, #00ff7f);
  background-size: 200% 200%;
  animation: Gradient 5s ease infinite;
}

@keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
*{
  margin: 0;
  padding: 0;
}
</style>
